import Image from 'app/Components/Shared/Image/image';
import React from 'react';

const DropDownOption = ({
  text,
  icon,
  isMenuOpen = false,
  grayBackgroundOnHover = false,
  notLastMenuElement = false,
  onClick = () => {},
  isSelected = false,
}) => {
  return (
    <div className={`business-dashboard-dropdown-option ${grayBackgroundOnHover ? 'show-gray-background' : ''}`} onClick={onClick}>
      <div className={`option-body ${notLastMenuElement ? 'not-last-menu-element' : ''}`}>
        {text && <span className={`option-text ${isSelected ? 'is-selected' : ''}`}>{text}</span>}
        {icon && <Image className={`option-icon ${isMenuOpen ? 'menu-is-open' : ''}`} src={icon} alt={text} />}
      </div>
    </div>
  );
};
export default DropDownOption;
